import { FunctionComponent } from 'react'

import { Icons } from 'atoms'
import { BottomSheetModal } from 'molecules'
import { RootStackScreenComponentProps, TabScreenComponentProps } from 'src/navigation'

// import { ActiveBase } from './components/ListNewOpportunities/ActiveBase'
import { Charge } from './components/ListNewOpportunities/Charge'
import { Concluded } from './components/ListNewOpportunities/Concluded'
import { Highlighted } from './components/ListNewOpportunities/Highlighted'
import { Insurance } from './components/ListNewOpportunities/Insurance'
import { ODC } from './components/ListNewOpportunities/ODC'
import { Pending } from './components/ListNewOpportunities/Pending'
import { ListOpportunities } from './components/ListOpportunities'
import { ListOpportunitiesByBusiness } from './components/ListOpportunitiesByBusiness'
import { ListOpportunitiesConcluded } from './components/ListOpportunitiesConcluded'
import { ListOpportunitiesHighlighted } from './components/ListOpportunitiesHighlighted'
import { ListOpportunitiesNotConcluded } from './components/ListOpportunitiesNotConcluded'

export type OrganizationScreenComponent = FunctionComponent<OrganizationScreenProps>

export type OrganizationScreenActivityComponent = FunctionComponent<OrganizationActivityScreenProps>

export type OrganizationScreenOpportunityComponent =
  FunctionComponent<OrganizationOpportunityScreenProps>

export type OrganizationScreenProps = TabScreenComponentProps<'Organization'>

export type OrganizationActivityScreenProps =
  RootStackScreenComponentProps<'OrganizationActivityList'>

export type OrganizationOpportunityScreenProps =
  RootStackScreenComponentProps<'OrganizationOpportunityList'>

export type ResponsiveProfileScreenComponent = FunctionComponent<ReturnType<UseOrganizationScreen>>

export interface Events {
  id: number
  name: string
  category: string
  tab: string
  value: string
}

export interface EventsByCategory {
  id: number
  title: string
  events: Events[]
}

export type ViewType = {
  title: string
  group: number
  icon: keyof typeof Icons
  combo?: boolean
}

export type PeriodTypes = {
  startingDay: string
  endingDay: string
}

export type ActivitiesGroup = { group: 1 | 2 | 3 | 4 }

export type OpportunitiesGroup = { group: ListType }

export type ViewModes = 'default' | 'kanban'

export type UseOrganizationScreen = ({
  navigation,
  route
}: Pick<OrganizationScreenProps, 'navigation' | 'route'>) => {
  tabs: TTab[]
  isMobile: boolean
  isLoading: boolean
  currentTab: 1 | 2
  viewType: ViewType
  viewTypes: ViewType[]
  ascOrDesc: 'asc' | 'desc'
  organizationValue: {
    total_activities: number
    total_opportunities: number
  }

  currentSelectedDate?: string
  currentSelectedPeriod?: {
    startingDay: string | undefined
    endingDay: string | undefined
  }
  handleToggleAscOrDesc: () => void
  setCurrentTab(index: 1 | 2): void
  handleToggleActivitiesTypeView: (viewType: ViewType, date: string) => void
  handleToggleActivitiesOrOpportunities: (id: 1 | 2 | number) => void
  navigation: OrganizationScreenProps['navigation']
  viewTypeSheetRef: React.RefObject<BottomSheetModal>
  openViewTypeSheet: () => void
  isPesados: boolean
  isGoodsAndServices: boolean
  handleGoToFilters: () => void
  handleGoToOrderByFilter: () => void
  activeFilterCount?: number
  activeOrderByFilterCount?: number
  route: OrganizationScreenProps['route']
}

export type TUserMessage = {
  avatarUri: string
  id: number
  name: string
  description: string
  amountToRead: number
  lastMessage: string
}

export type TTab = {
  id: 1 | 2 | number
  title: string
  show: boolean
}

export type FilterScreenProps = {
  modalVisible: boolean
  setModalVisible: (_: boolean) => void
}

export type ListTypesRef = {
  fetchMore?: () => void
  refetch: () => void
  refreshing?: boolean
  search(search: string): void
  clearSearch(): void
}

export type ListTypesView = {
  navigation: OrganizationScreenProps['navigation']
  handleSelect(vision: ViewType, date?: string): void
  data: {
    date?: string
    schedule_date_start?: string
    schedule_date_end?: string
  }
  ascOrDesc: 'asc' | 'desc'
  isLoading: boolean
  route: OrganizationScreenProps['route']
  openOpportunityFilterModal?: (listType: ListType) => void
}

export enum ListType {
  Pending = 13,
  Concluded = 10,
  Highlighted = 9,
  Charge = 8,
  Insurance = 7,
  ActiveBase = 6,
  ODC = 5
}

export const LIST_TYPES_NAMES = {
  [ListType.ActiveBase]: 'base_ativa',
  [ListType.Charge]: 'cobranca',
  [ListType.Concluded]: 'concluidas',
  [ListType.Highlighted]: 'destacadas',
  [ListType.Insurance]: 'seguro_auto',
  [ListType.ODC]: 'odc',
  [ListType.Pending]: 'pendentes'
}

export const OpportunitiesViewsV1: any = {
  10: ListOpportunitiesNotConcluded,
  9: ListOpportunities,
  8: ListOpportunitiesHighlighted,
  7: ListOpportunitiesConcluded,
  6: ListOpportunitiesByBusiness
}

export const OpportunitiesViewsV2: any = {
  13: Pending,
  10: Concluded,
  9: Highlighted,
  8: Charge,
  7: Insurance,
  // 6: ActiveBase, // we dont have active base for now
  5: ODC
}

export const monthNames = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Maio',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez'
]
